import { apiClient } from "./apiClient";

export interface WebhookCardapioEvent {
  id: number;
  payload: Record<string, unknown>;
  eventType: string | null;
  createdAt: string;
}

export interface WebhookCardapioEventosResponse {
  data: WebhookCardapioEvent[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PedidoIntegracao {
  id: number;
  orderId: number;
  displayId: number | null;
  statusIntegracao: string;
  items: unknown;
  createdAt: string;
  updatedAt: string;
}

export interface PedidosIntegracaoResponse {
  data: PedidoIntegracao[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface FilaJob {
  id: string;
  data: {
    orderId: number;
    webhookEventId: number;
  };
  attemptsMade: number;
  processedOn: number | null;
  finishedOn: number | null;
  failedReason: string | null;
}

export interface FilaStatusResponse {
  queue: string;
  stats: {
    waiting: number;
    active: number;
    completed: number;
    failed: number;
    delayed: number;
    total: number;
  };
  activeJobs: FilaJob[];
}

export interface ReprocessarResponse {
  message: string;
  pedidos: Array<{
    orderId: number;
    displayId: number | null;
    statusIntegracao: string;
  }>;
  jobsCreated: number;
}

export const webhookCardapioService = {
  getEventos: (page = 1, limit = 20): Promise<WebhookCardapioEventosResponse> =>
    apiClient.get<WebhookCardapioEventosResponse>(
      `/webhooks/cardapio/eventos?page=${page}&limit=${limit}`
    ),

  getFilaStatus: (): Promise<FilaStatusResponse> =>
    apiClient.get<FilaStatusResponse>("/webhooks/cardapio/fila/status"),

  getPedidos: (
    page = 1,
    limit = 20,
    status?: string
  ): Promise<PedidosIntegracaoResponse> => {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    if (status) params.append("status", status);
    return apiClient.get<PedidosIntegracaoResponse>(
      `/webhooks/cardapio/pedidos?${params}`
    );
  },

  reprocessarPendentes: (): Promise<ReprocessarResponse> =>
    apiClient.post<ReprocessarResponse>(
      "/webhooks/cardapio/reprocessar-pendentes",
      {}
    ),

  processarWebhooksAntigos: (): Promise<{
    message: string;
    totalWebhooksConfirmados: number;
    nuncaProcessados: number;
    comStatusPending: number;
    jaProcessadosComSucesso: number;
    enfileirados: number;
    pedidos: Array<{
      webhookId: number;
      orderId: number;
      eventType: string;
      motivo: string;
    }>;
    jobsCreated: number;
  }> => apiClient.post("/webhooks/cardapio/processar-webhooks-antigos", {}),

  limparFila: (): Promise<{
    message: string;
    before: {
      waiting: number;
      active: number;
      completed: number;
      failed: number;
      delayed: number;
      total: number;
    };
    after: {
      waiting: number;
      active: number;
      completed: number;
      failed: number;
      delayed: number;
      total: number;
    };
  }> => apiClient.post("/webhooks/cardapio/fila/limpar", {}),
};
